import { render, staticRenderFns } from "./ChargerBrand.vue?vue&type=template&id=0892d972&"
import script from "./ChargerBrand.vue?vue&type=script&lang=js&"
export * from "./ChargerBrand.vue?vue&type=script&lang=js&"
import style0 from "./ChargerBrand.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ChargerBrand.vue"
export default component.exports